import { endOfDay, max as maxDate, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import { NEGOTIATION_OVERVIEW_EARLIEST_DATE } from 'components/reports/Metrics/constants/NegotiationOverview'
import { BidNegotiationInputDtoInput } from 'generated/graphql'
import { resolveSupplierActivationPeriod } from 'helpers/metricsPeriod.helpers'

import { NegotiationOverviewFilterValues } from './NegotiationOverviewFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: BidNegotiationInputDtoInput
}

export const useNegotiationOverviewQueryInput = (): QueryInput => {
  const { control } = useFormContext<NegotiationOverviewFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const selectedServiceCodes = useWatch({ control, name: 'selectedServiceCodes' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === 'custom'

  const hasCompleteCustomRange = isCustom && customStart != null && customEnd != null

  const { start: rawStart, end } = hasCompleteCustomRange
    ? { start: startOfDay(customStart), end: endOfDay(customEnd) }
    : resolveSupplierActivationPeriod(period)

  const start = rawStart ? maxDate([rawStart, NEGOTIATION_OVERVIEW_EARLIEST_DATE]) : null

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      xeroCodeIds: selectedServiceCodes?.length
        ? selectedServiceCodes.map((option) => option.value)
        : null,
      vehicleType,
    },
  }
}
